import { getReconBillListRequest } from '@/assets/request/ReconRequest'
import {showLoading, hideLoading} from '@/js/loading'
import { Message } from 'element-ui'
function getPreviousDate(){
    const a = new Date()
    a.setMonth(a.getMonth()-1)
    return `${a.getFullYear()}-${a.getMonth()+1}-${a.getDate()}`
}
function getCurrentDate(){
    const a = new Date()
    return `${a.getFullYear()}-${a.getMonth()+1}-${a.getDate()}`
}

export default{
    state:{
        reconList:{
            list:[],
            page:1,
            pageSize:5,
            total:1,
            case_number:'',
            plate_number:'',
            vin:'',
            bill_sn:'',
            start_time:getPreviousDate(),
            end_time:getCurrentDate(),
            ins_name:'',
            repair_name:'',
            bill_status:-1,
            brand_name:'',
            inquiry_id:'',
            ins_inquiry_sn:'',
        }
    },
    mutations:{
        setReconListItem(state,obj){
            const o = Object.entries(obj)
            o.forEach(item=>state.reconList[item[0]] = item[1])
        },
        refreshList(state,{list, page, pageSize, total}){
            state.reconList.list = [...list]
            state.reconList.page = page
            state.reconList.pageSize = pageSize
            state.reconList.total = total
        }
    },
    actions:{
        requestListAction({state,commit}){
            const reconList = state.reconList
            showLoading()
            const d = Object.entries({
                page: reconList.page,
                page_size: reconList.pageSize,
                case_number:reconList.case_number,
                plate_number:reconList.plate_number,
                vin:reconList.vin,
                bill_sn:reconList.bill_sn,
                start_time:reconList.start_time,
                end_time:reconList.end_time,
                ins_name:reconList.ins_name,
                repair_name:reconList.repair_name,
                bill_status:reconList.bill_status,
                brand_name:reconList.brand_name,
                inquiry_id:reconList.inquiry_id,
                ins_inquiry_sn:reconList.ins_inquiry_sn,
            }).map(i=>{
                toString.call(i[1])==='[object String]'? i[1] = i[1].trim():0
                return i
            }).reduce((total,item)=>{
                total[item[0]] = item[1]
                return total
            },{})
            getReconBillListRequest(d).then(r=>{
                if(r.status!==200) {
                    Message.warning(r.statusText)
                    return hideLoading()
                }
                const { data } = r
                if(Number(data.code)!==200) {
                    Message.warning(data.msg)
                    return hideLoading()
                }
                commit('refreshList',{
                    list:data.data.list,
                    page: Number(data.data.page)?Number(data.data.page):1,
                    pageSize: Number(data.data.page_size)? Number(data.data.page_size): 1,
                    total: Number(data.data.total_num)? Number(data.data.total_num): 1
                })
                hideLoading()
            }).catch(r=>{
                const message = '获取复勘列表异常'
                console.trace({r,message})
                Message.error(message)
                hideLoading()
            })
        }
    },
    getters:{
        reconListGetter: state=>state.reconList
    }
}